export const selectLocation = (state) => state.location.currentCity;
